'use client'

import {useBlocksObserver, useHashChange, useTranslate} from '@local/hooks'
import {Suspense, useEffect, useRef, useState} from 'react'
import {cx} from '@local/utils/cx'
import {Button} from '@local/ui/components'
import type {LinkInput} from '@local/types'
import {HeaderSubmenu} from './HeaderSubmenu'
import LogoNav from '@local/assets/svgs/logo-nav.svg'
import {usePathname, useRouter} from 'next/navigation'
export type HeaderComponentProps = {
	chapterLinks: Array<{
		cta: LinkInput
		tag?: string
	}>
	socialClubLinks: Array<LinkInput>
	getInTouchLinks: Array<LinkInput>
	className?: string
}

const Hamburger = () => (
	<span className='flex flex-col items-center justify-between w-16 h-9 lg:w-18'>
		<span className='w-16 h-1 rounded bg-black lg:w-12 group-hover/btn:bg-white group-focus-visible/btn:bg-white' />
		<span className='w-16 h-1 rounded bg-black lg:w-12 group-hover/btn:bg-white group-focus-visible/btn:bg-white' />
		<span className='w-16 h-1 rounded bg-black lg:w-12 group-hover/btn:bg-white group-focus-visible/btn:bg-white' />
	</span>
)

const Logo = ({setOpenMenu, isDark}) => {
	const pathname = usePathname()
	const isLandingPage = pathname.includes('landing/')
	useEffect(() => {
		setOpenMenu(false)
	}, [pathname])

	return (
		<Button
			label='Homepage Link'
			className={cx(
				'absolute -translate-x-1/2 left-1/2',
			)}
			href={isLandingPage ? pathname : '/'}>
			<LogoNav
				className={cx(
					'block opacity-100 h-32 lg:h-40',
					'transition-color duration-300 ease-quint-out',
					isDark ? 'text-white' : 'text-black',
					pathname === '/career' && 'lg-max:text-white ',
				)} />
		</Button>
	)
}
export const HeaderComponent = ({className, chapterLinks, socialClubLinks, getInTouchLinks}: HeaderComponentProps) => {
	const locale = useTranslate()
	const [openMenu, setOpenMenu] = useState<boolean>(false)
	const pathname = usePathname()
	const router = useRouter()
	const ref = useRef<HTMLDivElement>(null)
	const isDark = useBlocksObserver(ref)
	const onClickClose = () => setOpenMenu(false)
	const isLandingPage = pathname.includes('landing/')

	useHashChange(() => {
		const hash = window.location.hash.slice(1)
		if (hash === 'experiences') {
			const el = document.getElementById('experiences')
			if (el) {
				el.scrollIntoView({behavior: 'smooth'})
			}
			setTimeout(() => {
				router.replace(window.location.pathname + window.location.search, {scroll: false})
			}, 100)
		}
		onClickClose()
	})

	return (
		<>
			<div
				ref={ref}
				className={cx(
					'fixed w-[calc(var(--grid-width)+var(--sbw))] margin-left-1 top-16 lg:top-20 z-3',
					'flex items-center justify-between',
					'transition-[color] duration-500 ease-expo-out',
					className,
				)}>

				<Button
					small
					variant='secondary'
					onClick={() => setOpenMenu(true)}
					label='Hambuger Menu'
					icon={<Hamburger />}
					className={cx('lg-max:hidden text-9 py-8', isLandingPage && 'hidden')}>
					{locale('Menu')}
				</Button>
				<Button
					variant='secondary-icon'
					small
					label='Hambuger Menu'
					onClick={() => setOpenMenu(true)}
					className={cx('lg:hidden px-16 aspect-square', isLandingPage && 'hidden')}>
					<Hamburger />
				</Button>

				<Suspense>
					<Logo isDark={isDark} setOpenMenu={setOpenMenu} />
				</Suspense>
			</div>

			<HeaderSubmenu
				isOpen={openMenu}
				onClickClose={onClickClose}
				chapterLinks={chapterLinks}
				socialClubLinks={socialClubLinks}
				getInTouchLinks={getInTouchLinks} />
		</>
	)
}
